import { Route, Routes } from 'react-router-dom';
import { SlidersPage } from './SlidersPage';
import { ModifySliderPage } from './ModifySlider/ModifySliderPage';

export const SliderPageRoot = () => (
  <Routes>
    <Route path='/new' element={<ModifySliderPage />} />
    <Route path='/:sliderID' element={<ModifySliderPage />} />
    <Route path='*' element={<SlidersPage />} />
  </Routes>
);
